/* global __ENVIRONMENT_VARS__ */
//this __ENVIRONMENT_VARS__ is replaced by webpack
export default __ENVIRONMENT_VARS__;